// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projectsFilterFullDiv
{
    -webkit-user-select: none;
            user-select: none;
    background-color: green;
}

.projectsFilterInterneDiv
{
    
    background-color: var(--dialog-content-backcolor);
    color: white;
    border-radius : 8px;
    width: 100%;
    -webkit-user-select: none;
            user-select: none;
    height: calc(100% - 60px);
    border: solid;
    border-width: 2px;
    border-color: var(--default-icon-color);
    margin-top: 10px;

    

}

.projectsFilterTitle
{
    padding-top: 5px;
    background-color: var(--dialog-title-backcolor);
    border-top-left-radius : 8px;
    border-top-right-radius : 8px;
    color: white;
    height: 30px;
    font-size: 15px;
    text-align: center;
    display: flex;
}
.projectsFilterTitleCloseButton
{
    width: 30px;
    background-color: transparent;
}
.projectsFilterTitleText
{
    background-color: transparent;
    width: calc(100% - 30px);

}


.projectsFilterButtonsDiv
{
    padding-top: 10px;
    padding-bottom: 5px;
    
    background-color: var(--dialog-buttons-backcolor);
    border-bottom-left-radius : 8px;
    border-bottom-right-radius : 8px;
    color: white;
    height: 30px;
    font-size: 15px;
    margin-top: 10px;
    text-align: right;
    
}




.projectsfilters-container
{
    overflow-y: scroll;
    margin-top: 5px;
    width: 99.7%;
    height: calc(100% - 76px)
    
}



.projectsfilters-container::-webkit-scrollbar-track {
    background: #101010; /* color of the tracking area */
  }
  
.projectsfilters-container::-webkit-scrollbar-thumb {
    background-color: #151515; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */
  }

.projectsfilters-container::-webkit-scrollbar{
    width:12px;
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/projectfilters/projectfilters.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAiB;YAAjB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;;;IAGI,iDAAiD;IACjD,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,yBAAiB;YAAjB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,uCAAuC;IACvC,gBAAgB;;;;AAIpB;;AAEA;;IAEI,gBAAgB;IAChB,+CAA+C;IAC/C,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;AACA;;IAEI,WAAW;IACX,6BAA6B;AACjC;AACA;;IAEI,6BAA6B;IAC7B,wBAAwB;;AAE5B;;;AAGA;;IAEI,iBAAiB;IACjB,mBAAmB;;IAEnB,iDAAiD;IACjD,+BAA+B;IAC/B,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;;AAErB;;;;;AAKA;;IAEI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ;;AAEJ;;;;AAIA;IACI,mBAAmB,EAAE,+BAA+B;EACtD;;AAEF;IACI,yBAAyB,EAAE,8BAA8B;IACzD,mBAAmB,EAAE,kCAAkC;IACvD,2CAA2C,EAAE,wCAAwC;EACvF;;AAEF;IACI,UAAU;AACd","sourcesContent":[".projectsFilterFullDiv\n{\n    user-select: none;\n    background-color: green;\n}\n\n.projectsFilterInterneDiv\n{\n    \n    background-color: var(--dialog-content-backcolor);\n    color: white;\n    border-radius : 8px;\n    width: 100%;\n    user-select: none;\n    height: calc(100% - 60px);\n    border: solid;\n    border-width: 2px;\n    border-color: var(--default-icon-color);\n    margin-top: 10px;\n\n    \n\n}\n\n.projectsFilterTitle\n{\n    padding-top: 5px;\n    background-color: var(--dialog-title-backcolor);\n    border-top-left-radius : 8px;\n    border-top-right-radius : 8px;\n    color: white;\n    height: 30px;\n    font-size: 15px;\n    text-align: center;\n    display: flex;\n}\n.projectsFilterTitleCloseButton\n{\n    width: 30px;\n    background-color: transparent;\n}\n.projectsFilterTitleText\n{\n    background-color: transparent;\n    width: calc(100% - 30px);\n\n}\n\n\n.projectsFilterButtonsDiv\n{\n    padding-top: 10px;\n    padding-bottom: 5px;\n    \n    background-color: var(--dialog-buttons-backcolor);\n    border-bottom-left-radius : 8px;\n    border-bottom-right-radius : 8px;\n    color: white;\n    height: 30px;\n    font-size: 15px;\n    margin-top: 10px;\n    text-align: right;\n    \n}\n\n\n\n\n.projectsfilters-container\n{\n    overflow-y: scroll;\n    margin-top: 5px;\n    width: 99.7%;\n    height: calc(100% - 76px)\n    \n}\n\n\n\n.projectsfilters-container::-webkit-scrollbar-track {\n    background: #101010; /* color of the tracking area */\n  }\n  \n.projectsfilters-container::-webkit-scrollbar-thumb {\n    background-color: #151515; /* color of the scroll thumb */\n    border-radius: 20px; /* roundness of the scroll thumb */\n    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */\n  }\n\n.projectsfilters-container::-webkit-scrollbar{\n    width:12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
